import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { AutoComplete, Button, ButtonType, CheckboxWithLabel, Column, Group, IconName, IconSize, Input, InputType, Row, Text, TextColor, } from '@as/cotopaxi';
import { Box, Stack } from '@yonderland/andes-react';
const getOpenAfterTime = (openAfterTime, storeTimeNotation) => {
    const hours = Math.floor(openAfterTime / 60);
    const minutes = openAfterTime % 60;
    const amPmNotation = hours >= 12 ? 'PM' : 'AM';
    return {
        hours: hours % storeTimeNotation,
        minutes: minutes !== 0 ? minutes : null,
        notation: storeTimeNotation === 12 ? amPmNotation : null,
    };
};
const defaultFiltersState = {
    openNow: false,
    openLate: false,
    openSunday: false,
    newShop: false,
};
export const StoreLocatorFilter = ({ defaultSearch = '', onFiltersChange, onSearchSubmit, openAfterTime, storeTimeNotation, errorMessage, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    const [filters, setFilters] = useState(defaultFiltersState);
    const [searchTerm, setSearchTerm] = useState(defaultSearch);
    const handleFilterChange = (filterKey) => (e) => {
        const newFilters = Object.assign(Object.assign({}, filters), { [filterKey]: e.target.checked });
        setFilters(newFilters);
        setSearchTerm('');
        onFiltersChange(newFilters);
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const handleSearchSubmit = () => {
        setFilters(defaultFiltersState);
        onSearchSubmit(searchTerm);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchSubmit();
        }
    };
    const filtersConfig = [
        {
            name: 'openNow',
            translationKey: 'store.opennow.txt',
        },
        {
            name: 'openLate',
            translationKey: 'store.openafter.txt',
            translationParams: getOpenAfterTime(openAfterTime, storeTimeNotation),
        },
        {
            name: 'openSunday',
            translationKey: 'store.sunday.txt',
        },
        {
            name: 'newShop',
            translationKey: 'store.openrecently.txt',
        },
    ];
    return (_jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(Row, { parent: true, children: _jsx(Column, { gutter: false, mobile: 12, mobileLarge: 12, tabletSmall: 12, tablet: 6, desktop: 4, desktopLarge: 4, children: _jsxs(Stack, { direction: "col", gap: "1", children: [_jsx(Input, { id: "store_filter", name: "store_filter", value: searchTerm, onKeyDown: handleKeyDown, onChange: handleSearchChange, type: InputType.SEARCH, placeholder: t('store.location'), autoComplete: AutoComplete.OFF, adornmentEnd: _jsx(Button, { dataQA: "store_locator_search_submit", onClick: handleSearchSubmit, type: ButtonType.SUBMIT, icon: { name: IconName.MAGNIFY, size: IconSize.MAJOR } }) }), errorMessage && _jsx(Text, { color: TextColor.NEGATIVE, children: t(errorMessage) })] }) }) }), _jsx(Group, { column: true, children: filtersConfig.map(filter => (_jsx(Box, { children: _jsx(CheckboxWithLabel, { id: filter.name, name: filter.name, value: filter.name, labelChildren: t(filter.translationKey, filter.translationParams), checked: filters[filter.name], onChange: handleFilterChange(filter.name) }) }, filter.name))) })] }));
};
